import type { PartnerSearchFilterItem } from '../models'

export const resolvePartnersFromTokens = (
  tokens: string[],
  partners: PartnerSearchFilterItem[]
): string[] => {
  const matched = new Set<string>()

  for (const token of tokens) {
    const lowerToken = token.toLowerCase()

    for (const partner of partners) {
      if (
        partner.PartnerId?.toLowerCase() === lowerToken ||
        partner.LocationId?.toLowerCase() === lowerToken ||
        partner.PartnerName?.toLowerCase() === lowerToken
      ) {
        matched.add(partner.PartnerId)
      }
    }
  }

  return Array.from(matched)
}
